import { combineActions, handleActions } from 'redux-actions'

import { uniqBy } from 'lodash'

import * as aiActions from '../actions'

const defaultState = []

export default handleActions(
  {
    [combineActions(
      aiActions.getUniqueAiObjectsByAnnotationIds.success,
      aiActions.getUniqueAiObjectsByIds.success,
      aiActions.getUniqueAiObjects.success
    )](state, { response }) {
      const uniqueAIObjects = response.data

      return uniqBy([...uniqueAIObjects, ...state], (o) => o.Id)
    },
    [aiActions.updateUniqueAiObjectSuccess](state, { payload, response }) {
      return state.map((object) => {
        if (object.Id === response.data.Id) {
          return response.data
        }

        return object
      })
    },
    [aiActions.addUniqueAiObjectConnection.success](state, { payload, response: { data: addedConnection } }) {
      return state.map((uniqueAIObject) => {
        if (uniqueAIObject.Id === addedConnection.Parent.Id) {
          return {
            ...uniqueAIObject,
            ChildConnections: [...uniqueAIObject.ChildConnections, addedConnection],
          }
        }

        if (uniqueAIObject.Id === addedConnection.Child.Id) {
          return {
            ...uniqueAIObject,
            ParentConnections: [...uniqueAIObject.ParentConnections, addedConnection],
          }
        }

        return uniqueAIObject
      })
    },
    [aiActions.deleteUniqueAiObjectConnection.success](state, { payload, response }) {
      const { uniqueAIObjectConnectionId: deletedConnectionId } = payload

      return state.map((uniqueAIObject) => {
        const newParentConnections = uniqueAIObject.ParentConnections.filter(
          (connection) => connection.Id !== deletedConnectionId
        )
        const newChildConnections = uniqueAIObject.ChildConnections.filter(
          (connection) => connection.Id !== deletedConnectionId
        )

        return {
          ...uniqueAIObject,
          ParentConnections: newParentConnections,
          ChildConnections: newChildConnections,
        }
      })
    },
    [aiActions.deleteUniqueAiObject.success](state, { payload: { uniqueAIObjectId } }) {
      return state
        .filter((uniqueAIObject) => uniqueAIObject.Id !== uniqueAIObjectId)
        .map((uniqueAIObject) => {
          const newParentConnections = uniqueAIObject.ParentConnections.filter(
            (connection) => connection.Parent.Id !== uniqueAIObjectId
          )
          const newChildConnections = uniqueAIObject.ChildConnections.filter(
            (connection) => connection.Child.Id !== uniqueAIObjectId
          )

          return {
            ...uniqueAIObject,
            ParentConnections: newParentConnections,
            ChildConnections: newChildConnections,
          }
        })
    },
    [combineActions(aiActions.addUniqueAiObject.success, aiActions.shallowCloneUniqueAiObject.success)](
      state,
      { payload, response }
    ) {
      const uniqueAIObject = response.data

      return uniqBy([uniqueAIObject, ...state], (o) => o.Id)
    },
    [aiActions.autofillPageUniqueAiObjects.success](state, { payload, response }) {
      const uniqueAIObjects = response.data

      return uniqBy([...uniqueAIObjects, ...state], (o) => o.Id)
    },
    [aiActions.resetState](state, payload) {
      return defaultState
    },
  },
  defaultState
)
